// Order-type resolution/validation for imports. Owns the whole decision so callers
// just pass inputs. wh_inventory keys off the row column, service off the item/service
// counts, and delivery/return/exchange off the converted items' is_return flags.
export const resolveOrderType = ({ rows = [], items = [], services = [], explicit } = {}) => {
    if (explicit) return explicit;

    if (rows.some((row) => row.order_type === 'wh_inventory')) {
        return 'wh_inventory';
    }

    if (services.length > 0 && items.length === 0) {
        return 'service';
    }

    const hasReturn = items.some((item) => item.is_return);
    const hasDelivery = items.some((item) => !item.is_return);

    if (hasReturn && hasDelivery) return 'exchange';
    if (hasReturn) return 'return';
    return 'delivery';
};

export const invalidOrderType = ({ orderType, rows = [] } = {}) => {
    // Only wh_inventory can be mixed-in illegally; service is now structurally
    // items-free (see resolveOrderType), so a service/non-service mix can't occur.
    if (orderType === 'wh_inventory' && rows.some((row) => row.order_type !== 'wh_inventory')) {
        return 'Inventory orders cannot contain non inventory lines with the same PO#';
    }

    return null;
};
